 /*
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

import {AbstractCrudObject} from './../abstract-crud-object';

/**
 * AudioRelease
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */
export default class AudioRelease extends AbstractCrudObject {
  static get Fields (): Object {
    return Object.freeze({
      album_title: 'album_title',
      asset_availability_status: 'asset_availability_status',
      audio_availability_status: 'audio_availability_status',
      audio_release_image_uri: 'audio_release_image_uri',
      created_time: 'created_time',
      displayed_artist: 'displayed_artist',
      ean: 'ean',
      genre: 'genre',
      grid: 'grid',
      id: 'id',
      isrc: 'isrc',
      label_name: 'label_name',
      original_release_date: 'original_release_date',
      parental_warning_type: 'parental_warning_type',
      proprietary_id: 'proprietary_id',
      upc: 'upc',
    });
  }


  
  get (fields: Array<string>, params: Object = {}): AudioRelease {
    // $FlowFixMe : Support Generic Types
    return this.read(
      fields,
      params
    );
  }
}
